import type { ScreenSchema } from './types';

const hotspotSchema: ScreenSchema = {
  template: 'hotspot',
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    }
    // Per-target lightbox audio uses `lightbox-{lightbox_${hostId}_${name}}` keys;
    // JiT prefetch via `collectHotspotTargetLightboxes` in jitEntryPrefetch.ts.
  }
};

export default hotspotSchema;
